import classNames from 'classnames';
import React, {FC, forwardRef} from 'react';
import {Button, ButtonProps} from '../Button';
import {Icon, IconProps} from '../Icon';
import styles from './ActionButton.module.scss';

type ActionButtonProps = ButtonProps & {
    iconName?: IconProps['name'];
};

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(({iconName, className, children, ...props}, ref) => {
    return (
        <Button ref={ref} {...props} variant="link-grey" size="lg" className={classNames(styles.actionButton, 'actionButton', className)}>
            <span className={styles.actionButtonLabel}>{children}</span>
            {iconName && <Icon name={iconName} position="end" size="lg" className={styles.actionButtonIcon} />}
        </Button>
    );
});
